/* eslint-disable import/prefer-default-export */
import headers from "./headers";

export const list = () => (
  fetch("/api/public/surveys", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
